import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-80px' }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, className = '' }) => (
  <span
    className={`inline-block text-[11px] sm:text-xs font-bold uppercase tracking-[0.28em] text-gold ${className}`}
  >
    {children}
  </span>
);
